import React, { useState } from 'react';
import Menu from '../Menu';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SuccessMessage from '../../components/successMessage';
import FailedMessage from '../../components/FailedMessage';
import useApiUrls from '../../useApiUrls';

const AddAudio = () => {
  const navigate = useNavigate();
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    File: null,
    Name: '',
    active: true
  });

  // State to hold API response or error
  const [message, setMessage] = useState('');

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'File') {
      setFormData((prevData) => ({
        ...prevData,
        File: files[0] // Only take the first file if multiple files are selected
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
    // const localStorageData = JSON.parse(localStorage.getItem('user'));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }
    
    const data = new FormData();
    data.append('File', formData.File);
    data.append('Name', formData.Name);
    data.append('active', formData.active);

    try {
      const AudioInsert = getUrlByOperation("AudioInsert");
      await axios.post(
        AudioInsert, 
        data,
        {
          headers: {
            'X-Authorization': token,
            'UserId': userid,
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      setMessage('Audio added successfully!');
      
      setTimeout(() => {
        navigate("/audio");
      }, 3000); 
    } catch (error) {
      setMessage('Failed to add audio.');
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Audio</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input 
                                type="text" 
                                className="form-control" 
                                value={formData.Name}
                                onChange={handleChange} 
                                placeholder="Enter ..." 
                                name="Name" 
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>File</label>
                              <input 
                                type="file" 
                                className="form-control" 
                                onChange={handleChange} 
                                placeholder="Enter ..." 
                                name="File" 
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select 
                                className="form-control" 
                                name="active" 
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        
                        <div className="form-footer">
                          <button type="submit" id="add-sub" className="btn btn-info">Add</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Audio added successfully!" ? 
        <SuccessMessage message={message} />
     : ""}


      {message === "Failed to add audio." ? 
        <FailedMessage message={message} />
         : ""}
    </>
  );
};

export default AddAudio;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}


